const ABOUT_CARDS = [
  {
    eyebrow: "How we work",
    title: "Build, then operate.",
    body:
      "Most engagements start with discovery and a bespoke build, then " +
      "transition into ongoing operations: infrastructure we manage, systems " +
      "we watch, and changes we ship as the business evolves. Full handoff " +
      "to your team is available when that's the preference.",
  },
  {
    eyebrow: "When work becomes product",
    title: "Domain-expert partnerships.",
    body:
      "Some of our best work begins with a client who has deep industry " +
      "expertise. When the system we build for them can also serve others " +
      "in their space, we co-develop it with them as a domain partner, and " +
      "they can hold a stake in the resulting product.",
  },
];

export default function About() {
  return (
    <section className="section section-tight" id="about">
      <div className="container">
        <header className="section-header">
          <p className="section-eyebrow">About</p>
          <h2 className="section-title">How we work.</h2>
          <p className="section-lede">
            We build bespoke cloud and AI systems for businesses, and prefer
            to host and operate them on an ongoing basis. Some engagements
            grow into products we co-build with domain-expert partners.
          </p>
        </header>
        <div className="card-grid">
          {ABOUT_CARDS.map((c) => (
            <article key={c.title} className="card">
              <p className="card-eyebrow">{c.eyebrow}</p>
              <h3 className="card-title">{c.title}</h3>
              <p className="card-body">{c.body}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
